function applyMeta(routes) {
  return routes.map((route) => ({
    ...route,
    meta: {
      ...(route.meta || {}),
      category: 'financial',
    },
  }));
}

export default applyMeta([
  {
    path: '/BestMoney',
    name: 'BestMoney',
    component: () => import('../../components/BestMoney.vue'),
  },
  {
    path: '/Easyloan',
    name: 'Easyloan',
    component: () => import('../../components/Easyloan.vue'),
  },
  // {
  //   path: '/loan',
  //   name: 'Loan',
  //   component: () => import('../../components/Loan.vue'),
  // },
  // {
  //   path: '/loan2',
  //   name: 'Loan2',
  //   component: () => import('../../components/Loan2.vue'),
  // },
  {
    path: '/loan1',
    name: 'Loan1',
    component: () => import('../../components/Loan1.vue'),
  },
  {
    path: '/MyAutoLoan',
    name: 'MyAutoLoan',
    component: () => import('../../components/MyAutoLoan.vue'),
  },
  {
    path: '/RedArrowLoans',
    name: 'RedArrowLoans',
    component: () => import('../../components/RedArrowLoans.vue'),
  },
  {
    path: '/FreddieMacLoan',
    name: 'FreddieMacLoan',
    component: () => import('../../components/FreddieMacLoan.vue'),
  },
]);
